(function ($) {

    if ($(".finding-slider").length) {

        let fSlider = $('.finding-slider__container');

        fSlider.slick({
            autoplay: false,
            accessibility: false,
            slidesToShow: 4,
            slidesToScroll: 1,
            infinite: true,
            draggable: true,
            arrows: true,
            prevArrow: $('.finding__slider--prev'),
            nextArrow: $('.finding__slider--next'),

            responsive: [{

                breakpoint: 992,
                settings: {
                    slidesToShow: 3,
                }

            }, {

                breakpoint: 768,
                settings: {
                    slidesToShow: 2,
                }

            }, {

                breakpoint: 576,
                settings: {
                    slidesToShow: 1,
                }

            }]
        });

        fSlider.on('afterChange', function (event, current, next) {
            event.stopPropagation();

        });
        fSlider.on('beforeChange', function (event, s, current, next) {
            event.stopPropagation();
        });

    }

})(jQuery);


// WEBPACK FOOTER //
// ./src/js/custom/finding-slider.es6